import React from "react";
import { Box } from "@vinomofo/components";
import { VinoDataOffer } from "../../types/vino-data-types";
import { Offers, skeletonList } from "../product-collection/ProductCollection";

const HITS_PER_PAGE = 4;
const COLUMN_COUNT = 4;

export interface RelatedOffersListProps {
  limit?: number;
  columns?: number;
  isPreferredPage?: boolean;
  recommendedOffers?: VinoDataOffer[];
  isLoading?: boolean;
  isShoppingCartPage?: boolean;
  backgroundColor?: string;
  engine?: string;
}

export const RelatedOffersList = (
  props: RelatedOffersListProps
): JSX.Element => {
  const {
    limit,
    columns,
    recommendedOffers,
    isLoading,
    isShoppingCartPage,
    backgroundColor,
    engine,
  } = props;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      flexDirection={["column", "column", "row"]}
      style={{
        paddingTop: "5px",
        backgroundColor: backgroundColor ? backgroundColor : "#fff",
      }}
    >
      <Box flexGrow={1}>
        {isLoading ? (
          <Offers
            offers={skeletonList(limit || HITS_PER_PAGE)}
            columns={columns || COLUMN_COUNT}
            skeleton={true}
            tidyUp={false}
            isPreferredPage={true}
            engine={engine}
          />
        ) : (
          recommendedOffers && (
            <>
              <Offers
                offers={recommendedOffers.slice(0, limit || HITS_PER_PAGE)}
                columns={columns || COLUMN_COUNT}
                skeleton={isLoading}
                tidyUp={isShoppingCartPage ? true : false}
                isPreferredPage={true}
                isRecommended={true}
                engine={engine}
              />
            </>
          )
        )}
      </Box>
    </Box>
  );
};
